type Props = {
  title: string;
};

const Component: React.FC<Props> = ({ title }) => {
  return (
    <div className="flex h-12 w-full items-center bg-[#eeeeee] pl-2 text-xl font-bold text-gray-600">
      {title}
    </div>
  );
};

export default Component;
